<template>
  <div class="product-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('contract_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-gavel</v-icon>{{$t('contract.contracts')}}</h1>
        </v-flex>
        <v-flex lg12>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandlerSub"
@contextmenu:row="showHandlerSubExt"
          >
          <template slot="item.start" slot-scope="{ item }">
            {{ formatDate(item['start'], 'long') }}
          </template>
          <template slot="item.valid" slot-scope="{ item }">
            <span v-if="item.valid" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
            <span v-else-if="item.valid == null" class="mr-2"><v-icon color="gray">mdi-help-circle</v-icon></span>
            <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandlerSub(item,'Contract',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ContractListCustomer',
  servicePrefix: 'Contract',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar
  },
  props: {
    customerParent: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t('contract.ref'), value: 'ref' },
        { text: this.$t('contract.type'), value: 'type.name' },
        { text: this.$t('contract.enable'), value: 'valid' },
      ],
      filters: {
        'customer' : this.customerParent['@id'],
      },
      selected: [],
    };
  },
  computed: {
    ...mapGetters('contract', {
      items: 'list'
    }),
    ...mapFields('contract', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('contract', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
  }
};
</script>
